// extracted by mini-css-extract-plugin
export var appear = "styles-module--appear--f8842";
export var appearDown = "styles-module--appear-down--e6ce6";
export var appearLeft = "styles-module--appear-left--15c42";
export var appearRight = "styles-module--appear-right--47ee1";
export var appearUp = "styles-module--appear-up--9f1e8";
export var container = "styles-module--container--092ac";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";